import { jsonApiClient } from 'shared/model';
import { Location } from '../@types';

const api = jsonApiClient('locations');

export const getLocations = (signal?: AbortSignal) => api.get<Location[]>(undefined, { signal });
